import { searchSwitchViewClick } from 'analytics/eventDefinitions'
import { addGTMEvent } from 'api/googleTagManager'
import ClickableLink from 'components/Common/Clickable/ClickableLink'
import MapViewBand from 'components/Common/MapViewBand'
import { useCallback } from 'react'
import noop from 'lib/function/noop'

interface Props {
  mapViewURL: string
  onClick?: () => void
}

function MapWindow(props: Props) {
  const { mapViewURL, onClick = noop } = props

  const handleClick = useCallback(() => {
    onClick()
    addGTMEvent(searchSwitchViewClick())
  }, [onClick])

  return (
    <ClickableLink to={mapViewURL} onClick={handleClick}>
      <MapViewBand />
    </ClickableLink>
  )
}

export default MapWindow
